import React from 'react';

// import animate on scroll
import Aos from 'aos';
import 'aos/dist/aos.css';

// import components
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import CtaSection from './components/CtaSection';
import Footer from './components/Footer';
import { Outlet } from 'react-router-dom';
import Header from './components/Header';

const App = () => {
  // animate on scroll initialization
  Aos.init({
    duration: 300,
    offset: 0,
  });
  return (
    <div className='overflow-hidden'>      
      <Header />
      <Outlet/>
      <Footer />
    </div>
  );
};

export default App;
